import React, { FC, ReactNode } from 'react';
import BannerStyled from './BannerStyled';
import setHtml from '~/helpers/setHtml';
import Tooltip from '../Tooltip';
import { InfoCircle } from '../Icons/outline';
import LegalAnnotation from '../LegalAnnotation';
import getAsset from '~/helpers/getAsset';

interface Props {
  text?: string;
  icon: ReactNode;
  iconName?: string;
  tooltip?: string;
  displayStyle?: string;
  iconColor?: string;
  iconBg?: string;
  useBackgroundTheme?: string;
  backgroundTheme?: string;
  legalKey?: string;
  netflixToggleLink?: {
    enabled?: string;
    text?: string;
  }
  setClickToToggleNetflixBundle?: (value: boolean) => void;
}

const Banner: FC<Props> = ({ text, icon, iconName, tooltip, displayStyle, children, iconColor, iconBg, useBackgroundTheme = 'false', backgroundTheme = 'default', legalKey, netflixToggleLink, setClickToToggleNetflixBundle }) => {
  const legalAnnotation = (legalKey && legalKey !== 'none' && <LegalAnnotation legalKey={legalKey} />) || null;
  const isNetflixBanner = iconName === 'netflix';
  return (
    <BannerStyled data-testid="banner" displayStyle={displayStyle} iconColor={iconColor} isNetflixBanner={isNetflixBanner} iconBg={iconBg} useBackgroundTheme={ useBackgroundTheme } backgroundTheme={ backgroundTheme }>
      <div className={`banner__icon-wrapper ${ (useBackgroundTheme === 'true') && `banner__icon-wrapper-${ backgroundTheme }` }` } data-testid="banner-icon">
        {isNetflixBanner ? <img src={getAsset('/images/logos/netflix-n-logo.svg')} alt="Netflix Logo" /> : icon}
      </div>
      <div className="banner__text-block">
        {text && (
          <span className="banner__text-bottom" data-testid="banner-text">
            <span {...setHtml(text)} />
            <span>{legalAnnotation}</span>
            {tooltip && (
              <Tooltip
                interactive
                position="top"
                theme="light"
                html={
                  <div style={{ width: 240 }}>
                    <div className="tooltip-info">
                      <span {...setHtml(tooltip as string)} />
                    </div>
                  </div>
                }
              >
                <InfoCircle />
              </Tooltip>
            )}
            &nbsp;
            {netflixToggleLink?.enabled === 'true' && <button className="banner__text-netflix" onClick={() => setClickToToggleNetflixBundle(true)}>{netflixToggleLink?.text !== 'none' ? netflixToggleLink?.text : 'Shop bundle plans'}</button>}
          </span>
        )}
        {children}
      </div>
    </BannerStyled>
  );
};

Banner.displayName = 'Banner';

export default Banner;
